












    import get from 'lodash/get';
    import { Component, Prop } from 'vue-property-decorator';
    import { moment } from '../app.config';
    import { discountsData } from '../globals';
    import BaseComponent from './Base';

    const dateFormat = 'YYYY-MM-DD';
    // const dateFormat = 'DD/MM/YYYY'; // In order to this module is working, we must change the date format

    @Component
export default class TourPriceDiscounts extends BaseComponent {
    @Prop({ type: Number, required: true }) protected readonly discountId: number;

    protected get filteredDiscounts(): any[] {
        return discountsData.filter((discount) => {
            if (discount.id !== this.discountId) {
                return;
            }

            // Current danish time
            const now = moment.utc().utcOffset(2);
            if (discount.days[now.isoWeekday()] !== true) {
                return;
            }

            // stop by date period
            let start = moment(discount.date.start, dateFormat, true).set({ hour: 0, minute: 0, second: 0 });
            let end = moment(discount.date.end, dateFormat, true).set({ hour: 0, minute: 0, second: 0 });
            if (!start.isValid() || !end.isValid() || !now.isBetween(start, end)) {
                return;
            }
            // stop by time period
            start = now.clone().set({ hour: Number(get(discount.time.start.split(':'), 0, 0)), minute: Number(get(discount.time.start.split(':'), 1, 0)), second: 0 });
            end = now.clone().set({ hour: Number(get(discount.time.end.split(':'), 0, 0)), minute: Number(get(discount.time.end.split(':'), 1, 0)), second: 0 });

            if (!now.isBetween(start, end)) {
                return;
            }
            // stop by time except dates
            let stop = false;
            discount.date.except.forEach((date) => {
                if (date === now.format(dateFormat)) {
                    stop = true;
                }
            });

            return !stop;
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TourPriceDiscounts.vue